/**
 * @generated SignedSource<<b7c596292df9bdafecf81f1fc2d8b9fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchGraphConfluenceDc_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly container?: {
      readonly displayName?: string | null;
      readonly url?: string | null;
    } | null;
    readonly reactions?: ReadonlyArray<{
      readonly reactionType: string | null;
      readonly total: number | null;
    } | null> | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly subtype: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphConfluenceDc_AtlassianSearchPage";
};
export type searchGraphConfluenceDc_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphConfluenceDc_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphConfluenceDc_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphConfluenceDc_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subtype"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    },
                    (v0/*: any*/)
                  ],
                  "type": "ExternalSpace"
                }
              ]
            },
            {
              "concreteType": "ExternalReaction",
              "kind": "LinkedField",
              "name": "reactions",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "reactionType"
                },
                {
                  "kind": "ScalarField",
                  "name": "total"
                }
              ]
            }
          ],
          "type": "ExternalDocument"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "84328c11caa37465be9e406ec32593d9";

export default node;
